import { render, staticRenderFns } from "./logo-uploader.vue?vue&type=template&id=35ecb74d"
import script from "./logo-uploader.ts?vue&type=script&lang=js&external"
export * from "./logo-uploader.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports